import Setting from './Setting';

export default Setting
export { Setting as Base }
